import React from 'react'
import { SimpleTabs } from '@/components/lib'

import useStore from '../../../store'
import useTitle from '../../../hooks/useTitle'
import ParticipantMessaging from './Messages'
import AutomaticMessages from './Automatic'

export default function Messages () {
  const { trial } = useStore()
  useTitle('Messages', trial)
  return (
    <SimpleTabs
      tabs={[
        { title: 'Participant messenger', content: <ParticipantMessaging /> },
        { title: 'Automatic messages', content: <AutomaticMessages /> }
      ]}
    />
  )
}
